import { apiConfig } from '../../config';
import { request, withErrorHandling, withRetry } from '../SetDirection';
import { createApiPolling } from 'common/utils/helpers';

export async function setCenterArfcn(params, options = {}) {
  const checkStatus = await callSetCenterArfcn(params, options);

  const result = await waitUntilStatusCompleted(checkStatus, options);
  if (result?.runtimeStatus === 'Completed' && result?.customStatus?.status === 'error') {
    throw new Error(result.customStatus?.message || 'Something went wrong. Please try again later.');
  }
  return result;
}

export function callSetCenterArfcn(params, options = {}) {
  const { deviceId, centerFreq, bandwidth } = params;
  const url = apiConfig.cmServiceSetCenterArfcn(deviceId);
  const body = JSON.stringify({
    'center-arfcn': centerFreq,
    bandwidth: bandwidth
  });

  return withErrorHandling(withRetry(request, options.retry))(url, {
    method: 'POST',
    body
  });
}

function isActiveInstanceStatus(status) {
  return ['Pending', 'Running'].includes(status.runtimeStatus);
}

export function waitUntilStatusCompleted({ statusQueryGetUri }, options) {
  return createApiPolling(
    withErrorHandling(request),
    (status) => status != null && !isActiveInstanceStatus(status),
    options
  )(statusQueryGetUri);
}
